import React from 'react';

// Reusable building blocks for service pages

export const SectionWrap = ({ children, className = '', testId, bg = 'white' }) => {
  const bgCls = bg === 'ivory' ? 'bg-ivory' : 'bg-white';
  return (
    <section className={`${bgCls} py-20 lg:py-28 ${className}`} data-testid={testId}>
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">{children}</div>
    </section>
  );
};

export const SectionHeader = ({ eyebrow, title }) => (
  <div className="mb-12">
    {eyebrow && <div className="overline mb-5">{eyebrow}</div>}
    {title && <h2 className="display-md text-cyan-vidat max-w-3xl">{title}</h2>}
    <span className="section-rule mt-10"></span>
  </div>
);

export const Bullets = ({ items, testId }) => (
  <ul className="space-y-4 mt-2" data-testid={testId}>
    {items.map((item, i) => (
      <li key={i} className="flex gap-4 items-start text-stone-700 font-light leading-relaxed">
        <span className="block mt-[0.7em] w-3 h-px bg-[#0936F6] flex-shrink-0"></span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export const TitledBullets = ({ items, testId }) => (
  <ul className="divide-y divide-stone-200/70" data-testid={testId}>
    {items.map(([title, body], i) => (
      <li key={i} className="py-5 grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6">
        <div className="md:col-span-4 text-cyan-vidat font-medium tracking-tight">{title}</div>
        <div className="md:col-span-8 text-stone-700 font-light leading-relaxed">{body}</div>
      </li>
    ))}
  </ul>
);

export const Prose = ({ paragraphs, testId }) => (
  <div className="prose-vidat max-w-3xl" data-testid={testId}>
    {paragraphs.map((p, i) => (
      <p key={i}>{p}</p>
    ))}
  </div>
);
